import { createAsyncThunk } from '@reduxjs/toolkit'
import { createWebSearchItem } from '../../services/web-search'

export const createWebSearchItemAction = createAsyncThunk(
  'web-search-item/create',
  async ({ app_item }, { rejectWithValue }) => {
    const app_item_id = app_item.id
    const estimate = app_item.estimate_field
    try {
      const response = await createWebSearchItem({
        data: { app_item: app_item_id, estimate },
      })
      return response.data
    } catch (e) {
      return rejectWithValue(e.response.data)
    }
  }
)
